import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation()

  // don’t scroll to top on first render
  const isFirstRun = useRef(true)

  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false
      return
    }

    window.scrollTo(0, 0)
  }, [pathname])

  return null
}

export default ScrollToTop
